import React from 'react';
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import APPCONFIG from 'constants/Config';
import PrivacyPolicy from "../Parts/PrivacyPolicy";
import TermsOfService from "../Parts/TermsOfService";

export default class Footer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			openPrivacy: false,
			openTOS: false
		};
	}

	toggle = (modal) => {
		this.setState(prev => ({ [modal]: !prev[modal] }));
	}

	openModalPrivacy = (e) => {
		e.preventDefault();
		this.toggle("openPrivacy");
	}

	openModalTOS = (e) => {
		e.preventDefault();
		this.toggle("openTOS");
	}

  render() {
    return (
      <section className="app-footer no-print">
        <div className="container-fluid">
          <span className="float-left" style={{ whiteSpace: "pre" }}>
	          <span>Version {process.env.version} | {APPCONFIG.copyright}-{APPCONFIG.year} © <a className="brand" target="_blank" href={APPCONFIG.productLink}>{process.env.author.name}</a> | <a className="brand" style={{ cursor: "pointer" }} onClick={this.openModalPrivacy}>Privacy Policy</a> | <a className="brand" style={{ cursor: "pointer" }} onClick={this.openModalTOS}>Terms of Service</a>
	          </span>
	          {/*TODO: in the future add privacy policy and terms of service*/}
          </span>
          <span className="float-right">
	          <span>ServiceBookr powered by <a href={process.env.author.url} target="_blank">{process.env.author.name}</a></span>
          </span>
        </div>
	      <Modal isOpen={this.state.openPrivacy} toggle={() => this.toggle("openPrivacy")} size={"lg"}>
		      <ModalHeader toggle={() => this.toggle("openPrivacy")}>Privacy Policy</ModalHeader>
		      <ModalBody>
			      <PrivacyPolicy />
		      </ModalBody>
	      </Modal>
	      <Modal isOpen={this.state.openTOS} toggle={() => this.toggle("openTOS")} size={"lg"}>
		      <ModalHeader toggle={() => this.toggle("openTOS")}>Terms Of Service</ModalHeader>
		      <ModalBody>
			      <TermsOfService />
		      </ModalBody>
	      </Modal>
      </section>
    );
  }
}
